var map = {
	"./18_PW.png": 12980,
	"./19PW.png": 63545,
	"./20PW.png": 1574,
	"./PW21.png": 40776,
	"components/Catalog/PW/img/glass/lw/lwPlusGrafit/18_PW.png": 12980,
	"components/Catalog/PW/img/glass/lw/lwPlusGrafit/19PW.png": 63545,
	"components/Catalog/PW/img/glass/lw/lwPlusGrafit/20PW.png": 1574,
	"components/Catalog/PW/img/glass/lw/lwPlusGrafit/PW21.png": 40776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60654;